import { defineStore } from "pinia";
import { Ref } from "vue";
import { ITeam, INewTeam } from "@/features/teams/team.types";
import { ITableHeader } from "@/types/table";
import { teamService } from "./team.service";
import { useNotification } from "@/utils/notification";
const { pushNotification } = useNotification();

export const useTeamStore = defineStore("team", () => {
  const teamsForFilter: ITeam[] = [];
  //   const teamHeaders: ITableHeader[] = [
  //     {
  //       name: "id",
  //       label: "No",
  //       fitContent: true,
  //     },
  //     {
  //       name: "title",
  //       label: "Team name",
  //       width: "300px",
  //     },
  //     {
  //       name: "start_time",
  //       label: "Start",
  //       width: "300px",
  //     },
  //     {
  //       name: "end_time",
  //       label: "End",
  //     },
  //     {
  //       name: "is_active",
  //       label: "Status",
  //       width: "150px",
  //     },
  //     {
  //       name: "kpi",
  //       label: "KPI",
  //       width: "150px",
  //     },
  //     {
  //       name: "kpi_progress",
  //       label: "KPI Progress",
  //       width: "150px",
  //     },
  //     {
  //       name: "actions",
  //       label: "Actions",
  //       fitContent: true,
  //     },
  //   ];

  async function getTeams(loading: Ref<boolean>): Promise<ITeam[]> {
    try {
      loading.value = true;
      const { data } = await teamService.getTeams();
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return [] as any;
    } finally {
      loading.value = false;
    }
  }

  async function createTeam(loading: Ref<boolean>, payload: INewTeam) {
    try {
      loading.value = true;
      const { data } = await teamService.createTeam(payload);
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return {} as any;
    } finally {
      loading.value = false;
    }
  }

  async function updateTeam(
    loading: Ref<boolean>,
    payload: INewTeam,
    id: string
  ) {
    try {
      loading.value = true;
      const { data } = await teamService.updateTeam(id, payload);
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return {} as any;
    } finally {
      loading.value = false;
    }
  }

  async function seedDefaultTeam(loading: Ref<boolean>) {
    try {
      loading.value = true;
      const { data } = await teamService.seedDefaultTeam();
      return data;
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      pushNotification(message, "error");
      return {} as any;
    } finally {
      loading.value = false;
    }
  }

  return {
    teamsForFilter,
    // teamHeaders,
    getTeams,
    createTeam,
    updateTeam,
    seedDefaultTeam,
  };
});
